export type IProjectsIDsResponse = {
  archived: string[];
  notArchived: string[];
};

import { TProject } from '@/types/global';
import { getBaseUrl } from '@/utils/generic';
import { IGetProjectsParams } from '../projects/types';

export interface IFilteredProjectsResponse {
  projects: TProject[];
  _fromCache: boolean;
}
/**
 * Fetches filtered projects from the API using GET
 */
export async function fetchProjectsIDs(params: IGetProjectsParams): Promise<IProjectsIDsResponse> {
  const defaultParams = {
    count: -1,
    search: '',
    status: 'published',
    isArchived: false,
  };

  const mergedParams = { ...defaultParams, ...params };

  // Clean null or undefined values
  const cleanedParams = Object.fromEntries(
    Object.entries(mergedParams).filter(([, v]) => v !== undefined && v !== null)
  );

  // Convert arrays to comma-separated strings
  const queryParams = new URLSearchParams();
  for (const [key, value] of Object.entries(cleanedParams)) {
    if (Array.isArray(value)) {
      if (value.length > 0) queryParams.append(key, value.join(','));
    } else {
      queryParams.append(key, String(value));
    }
  }

  const url = `${getBaseUrl()}/api/projects-ids?${queryParams.toString()}`;

  const res = await fetch(url, {
    method: 'GET'
  });

  if (!res.ok) {
    const errorBody = await res.json().catch(() => ({}));
    throw new Error(errorBody?.message || `Failed to fetch projects (${res.status})`);
  }

  return res.json();
}
